import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState, AppThunk } from './store'
import { get } from '../utils/rest'
import { PageBase, OrganisationPage, LoginPage, StartPage } from '../types/types'
import * as Toast from 'components/Toast'

export interface Page {
  title: string
  preamble: string
  mainBody: string
}

export interface PageState {
  isLoading: boolean
  page: PageBase | OrganisationPage | LoginPage | StartPage | undefined | null
}

const createInitialState = (): PageState => {
  return {
    isLoading: false,
    page: null,
  }
}

export const pageSlice = createSlice({
  name: 'page',
  initialState: createInitialState(),
  reducers: {
    fetchPageBegin: (state) => {
      state.isLoading = true
    },
    fetchPageSuccess: (
      state,
      action: PayloadAction<PageBase | OrganisationPage | LoginPage | StartPage | undefined | null>,
    ) => {
      state.page = action.payload
      state.isLoading = false
    },
    clearState: (state) => {
      state.page = null
    },
  },
})

export const { fetchPageBegin, fetchPageSuccess, clearState } = pageSlice.actions

export const clearPageState = (): AppThunk => async (dispatch) => {
  dispatch(clearState())
}

export const fetchPageAsync =
  (slug: string): AppThunk =>
  async (dispatch) => {
    dispatch(fetchPageBegin())

    try {
      const res = await get<PageBase | OrganisationPage | LoginPage | undefined | null>(`/api/content/page/${slug}`)
      if (res.status === 200) {
        dispatch(fetchPageSuccess(res.parsedBody?.data))
      }
    } catch {
      Toast.dispatchToastError({ message: 'Fel vid hämtning av sida' })
    }
  }

export const fetchStartPageAsync = (): AppThunk => async (dispatch) => {
  dispatch(fetchPageBegin())
  try {
    const res = await get<StartPage | undefined | null>(`/api/content/page/startpage`)
    if (res.status === 200) {
      dispatch(fetchPageSuccess(res.parsedBody?.data))
    }
  } catch {
    Toast.dispatchToastError({ message: 'Fel vid hämtning av sida' })
  }
}

export const selectPageState = (state: RootState): PageState => state.page
export const selectPageStatePage = (
  state: RootState,
): PageBase | OrganisationPage | LoginPage | StartPage | undefined | null => state.page.page

export default pageSlice.reducer
